<template>
  <ux-modal-dialog @open="onOpen" :show="show" @close="cancel">
    <div class="asset-image">
      <img :src="asset.url" alt>
    </div>
    <div class="input-h-group">
      <label class="form-label">Title</label>
      <input
        ref="inputTitle"
        type="text"
        @change="updateTitle"
        @keyup.enter="updateAsset"
        @click="select"
        v-model="name"
      >
    </div>
    <div class="input-h-group">
      <label class="form-label">Tags</label>
      <input type="text" @change="updateTags" v-model="tags">
    </div>
    <div class="flex-spread">
      <button @click="updateAsset">Save Changes</button>
      <button class="icon-circle danger">
        <i class="material-icons" @click="deleteAsset">delete_forever</i>
      </button>
    </div>
  </ux-modal-dialog>
</template>

<script>
import UxModalDialog from "./UxModalDialog.vue";

export default {
  components: {
    UxModalDialog
  },
  props: ["show", "asset"],
  data() {
    return {
      name: null,
      tags: null
    };
  },
  created() {
    this.name = this.asset.name;
    this.tags = this.asset.tags;
  },
  methods: {
    onOpen() {},
    select(ev) {},
    updateTitle(ev) {},
    updateTags(ev) {},
    updateAsset() {
      let newAsset = { ...this.asset, name: this.name, tags: this.tags };
      this.$store.dispatch("updateAsset", newAsset);
      this.$emit("close");
    },
    deleteAsset() {
      this.$store.dispatch("deleteItem", this.asset);
      this.$emit("close");
    },
    cancel() {
      this.$emit("close");
    },
    confirmDelete() {
      this.$emit("close");
    }
  }
};
</script>
<style lang="scss" scoped>
div.asset-image {
  background: black;
  padding: 1rem;
  height: 200px;
  display: flex;
  align-items: center;
  img {
    margin: 0 auto;
    max-height: 100%;
    width: inherit;
  }
}
button.icon-circle.danger {
  position: absolute;
  right: 2rem;
  margin: 10px 0;
}
button.edit-image {
  margin: 10px 0 5px;
  padding: 2px 0;
  width: 100%;
  justify-content: center;
  background: #35373a;
  color: #ccc;
  font-size: 1.3rem;
  font-weight: 300;
  text-shadow: none;
  border-top: 1px solid #4a4d52;
}
</style>
